import { Grid, Skeleton } from '@mui/material';

function ThreeLineSkeleton() {
  return (
    <Grid padding={1} paddingX={3}>
      <Skeleton variant='text' width={'100%'} height={30} />
      <Skeleton variant='text' width={'100%'} height={30} />
      <Skeleton variant='text' width={'100%'} height={30} />
    </Grid>
  );
}

export default ThreeLineSkeleton;
